module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "element element-container-single element-non-bodymatter element-type-none element-with-heading",
    attrs: {
      "id": "uncategorized-3"
    }
  }, [_c('div', {
    staticClass: "heading heading-with-title heading-without-image",
    attrs: {
      "id": "uncategorized-3-heading"
    }
  }, [_c('div', {
    staticClass: "heading-contents"
  }, [_c('div', {
    staticClass: "title-subtitle-block title-block-without-element-number"
  }, [_c('div', {
    staticClass: "element-number-block"
  }), _vm._v(" "), _c('div', {
    staticClass: "title-block"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Praise for Bill Ransom")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "text",
    attrs: {
      "id": "uncategorized-3-text"
    }
  }, [_c('p', {
    staticClass: "first first-in-chapter first-full-width"
  }, [_c('i', [_vm._v("“A novel of vampire seduction, murder, intrigue, and blood. Accomplished poet and novelist Bill Ransom uses humor in especially delicious ways.”")])]), _vm._v(" "), _c('div', {
    staticClass: "alignment-block alignment-block-align-right"
  }, [_c('div', {
    staticClass: "text-block"
  }, [_c('p', {
    staticClass: "alignment-block-content alignment-block-content-right"
  }, [_vm._v("—Brian Herbert, New York Times bestselling coauthor of "), _c('i', [_vm._v("Dune: House Atreides")])])])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_c('i', [_vm._v("“")]), _vm._v("Brother Blood, Sister Death"), _c('i', [_vm._v(" is a classic vampire novel rife with secrets … but it’s no secret that I loved it! Complicated relationships and unexpected twists and turns mix with good old-fashioned vampire violence for a great read. More, Bill Ransom!”")])]), _vm._v(" "), _c('div', {
    staticClass: "alignment-block alignment-block-align-right"
  }, [_c('div', {
    staticClass: "text-block"
  }, [_c('p', {
    staticClass: "alignment-block-content alignment-block-content-right"
  }, [_vm._v("—Nancy Holder, New York Times bestselling coauthor of the Wicked Series")])])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_c('i', [_vm._v("“")]), _vm._v("Brother Blood, Sister Death"), _c('i', [_vm._v(" is a highly entertaining, riveting story about twin adult vampires. Daniel and Diana struggle to live in the human world, but Diana’s appetite for killings goes beyond survival. Daniel worries about his own safety, and things become bloody twisted. Couldn’t put this one down—definitely worth a bite.”")])]), _vm._v(" "), _c('div', {
    staticClass: "alignment-block alignment-block-align-right"
  }, [_c('div', {
    staticClass: "text-block"
  }, [_c('p', {
    staticClass: "alignment-block-content alignment-block-content-right"
  }, [_vm._v("—Anna Quinn, author of "), _c('i', [_vm._v("The Night Child")]), _vm._v(" (Psychological Thriller, Blackstone, 2018)")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-04f79b38","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/praiseforbillransom.vue
// module id = 63
// module chunks = 0